    <div class="kp-table-label-printed d-flex flex-column">
    <!--<h5>Geprint</h5>-->

        <table mat-table [dataSource]="dataSource" class="w-100 example-table table-rounded-corners" matSort
               matSortActive="leverDatumTijdstip" matSortDisableClear matSortDirection="asc" [trackBy]="trackById">

            <!-- labelIsCreated Column -->
            <ng-container matColumnDef="labelIsCreated">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox [(ngModel)]="isAllSelected" (change)='markAll()' *ngIf="_data?.length"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox [(ngModel)]="row.selected" (change)='toggleSelected(row)'></mat-checkbox>
                </td>
            </ng-container>

            <!-- orderNr Column -->
            <ng-container matColumnDef="orderNr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Ordernr</th>
                <td mat-cell *matCellDef="let row">{{row.orderNr}}</td>
            </ng-container>

            <!-- datumAangemaakt Column -->
            <ng-container matColumnDef="datumAangemaakt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Aangemaakt</th>
                <td mat-cell *matCellDef="let row">{{row.datumAangemaakt | date:'dd-MM-yyyy HH:mm'}}</td>
            </ng-container>

            <ng-container matColumnDef="debiteurNrs">
                <th mat-header-cell *matHeaderCellDef disableClear>Debiteur</th>
                <td mat-cell *matCellDef="let row">
                    <span *ngIf="row.debiteurNrs.length == 1">{{row.debiteurNrs}}</span>
                    <span *ngIf="row.debiteurNrs.length > 1"
                          matTooltip="{{row.debiteurNrs.join(', ')}}">{{row.debiteurNrs[0]}}...</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="afmetingStickers">
                <th mat-header-cell *matHeaderCellDef disableClear>Afmeting sticker</th>
                <td mat-cell *matCellDef="let row">
                    <span *ngIf="row.afmetingStickers?.length == 1">{{row.afmetingStickers[0]}}</span>
                    <span *ngIf="row.afmetingStickers?.length > 1"
                          matTooltip="{{row.afmetingStickers.join(', ')}}">{{row.afmetingStickers[0]}}...</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="leverDatumTijdstip">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Leverdatum</th>
                <td mat-cell *matCellDef="let row">{{row.leverDatumTijdstip | date: 'dd-MM-yyyy'}}</td>
            </ng-container>

            <ng-container matColumnDef="leverTijdstip">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Levertijdstip</th>
                <td mat-cell *matCellDef="let row">{{row.leverTijdstip}}</td>
            </ng-container>

            <ng-container matColumnDef="kwekerArtikelNr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Kwekerartikelnr</th>
                <td mat-cell *matCellDef="let row">{{row.kwekerArtikelNr}}</td>
            </ng-container>

            <ng-container matColumnDef="klantArtikelOmschrijving">
                <th mat-header-cell *matHeaderCellDef disableClear>Artikelomschrijving</th>
                <td mat-cell *matCellDef="let row">{{row.klantArtikelOmschrijving}}</td>
            </ng-container>

            <ng-container matColumnDef="potmaat">
                <th mat-header-cell *matHeaderCellDef disableClear>Potmaat</th>
                <td mat-cell *matCellDef="let row">{{row.potmaat}}</td>
            </ng-container>

            <ng-container matColumnDef="barCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Barcode</th>
                <td mat-cell *matCellDef="let row">{{row.barCode}}</td>
            </ng-container>

            <ng-container matColumnDef="aantalFustLabels">
                <th mat-header-cell *matHeaderCellDef disableClear>Aantal fustlabels</th>
                <td mat-cell *matCellDef="let row">{{row.aantalFustLabels}}</td>
            </ng-container>

            <ng-container matColumnDef="aantalProductLabels">
                <th mat-header-cell *matHeaderCellDef disableClear>Aantal productlabels</th>
                <td mat-cell *matCellDef="let row">{{row.aantalProductLabels}}</td>
            </ng-container>

            <ng-container matColumnDef="aanleverwijze">
                <th mat-header-cell *matHeaderCellDef disableClear><strong>Aanleverwijze</strong></th>
                <td mat-cell *matCellDef="let row"><strong>{{row.aanleverwijze}}</strong></td>
            </ng-container>

            <ng-container matColumnDef="productStickerlocatie">
                <th mat-header-cell *matHeaderCellDef disableClear>Product stickerlocatie</th>
                <td mat-cell *matCellDef="let row">{{row.productStickerlocatie}}</td>
            </ng-container>

            <ng-container matColumnDef="fustStickerlocatie">
                <th mat-header-cell *matHeaderCellDef disableClear>Fust stickerlocatie</th>
                <td mat-cell *matCellDef="let row">{{row.fustStickerlocatie}}</td>
            </ng-container>

            <ng-container matColumnDef="opmerkingInstructie">
                <th mat-header-cell *matHeaderCellDef disableClear>Opmerking/instructie</th>
                <td mat-cell *matCellDef="let row">{{row.opmerkingInstructie}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" sticky></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.kp-modified]="row.selected"></tr>
        </table>

        <mat-paginator
                [length]="totalCount"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                [pageSizeOptions]="[5, 10, 25, 50, 100, totalCount]"
                (page)="onPage($event)">
        </mat-paginator>

    </div>
